exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrolling-block[data-v-b6bf1ce6]{display:flex;align-items:center;overflow-x:hidden}.block-container[data-v-b6bf1ce6]{white-space:nowrap;overflow-x:hidden;display:flex;align-items:flex-end;flex-grow:1}.spec-button[data-v-b6bf1ce6]{cursor:pointer;display:block;height:36px;line-height:36px;background:#ccc;padding-left:3px;padding-right:3px;color:#5a6268;border-radius:5px}.spec-button[data-v-b6bf1ce6]:first-child{margin-right:5px}.spec-button[data-v-b6bf1ce6]:last-child{margin-left:5px}.spec-button[data-v-b6bf1ce6]:hover{background:hsla(0,0%,80%,.5411764705882353)}", ""]);

// exports
